module.exports = __webpack_public_path__ + "static/media/crocodile(22).e0bc935e.PNG";